
import Vue from 'vue'
import router from 'vue-router'

Vue.use(router);
import FootNav from '../../components/FootNav.vue'
import Card from 'vux/src/components/card/index.vue'

import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
filters: {
level(value) {
if (value === 4) {
return '高级会员'
}
if (value === 3) {
return '中级会员'
}
if (value === 2) {
return '初级会员'
}
if (value === 1) {
return '普通会员'
}
}
},
components: {
FootNav,
Card,
Grid,
GridItem,
GroupTitle,
XDialog,
Group,
Cell,
XButton,
Blur,
Divider
},
data() {
return {
show_recharge: false,
showAgentSection:false,
showSellerRequest:false,
checkTrueName: false,
bgImg: '',
showQr: false,
qrCode: '',
info: '',
header1: '我的账户',
showUi: false,
version: '2.0.20190930',
fontColor: '#fff',
show_get_back:false,
}
},
mounted: function () {
document.title = '个人中心'
this.$nextTick(function () {
this.$vux.loading.show({
text: '加载中'
});
const url = this.tianYiWebUrl + '/wechat/uc/index';
this.$http.get(url).then(r => {
if (r.data.code === 200) {
this.bgImg = r.data.data.bg;
this.info = r.data.data.userInfo;
this.info.orderNumber = r.data.data.orderNumber;
this.info.promiseBalance = r.data.data.promise_balance;
this.info.promiseBalanceList = r.data.data.promise_balance_list;
this.info.agentArea = r.data.data.agentAreaFullName;
this.info.checkInformation = r.data.data.checkInformation;
this.show_recharge = r.data.data.show_recharge;
this.show_get_back = r.data.data.show_get_back;
this.showSellerRequest = r.data.data.show_seller_request,
this.showAgentSection = r.data.data.show_agent_section;
this.checkTrueName = r.data.data.checkTrueName;
if (r.data.data.fontColor) {
this.fontColor = r.data.data.fontColor;
}
this.showUi = true;
this.$vux.loading.hide();
if (this.checkTrueName === true && r.data.data.userInfo.true_name === '') {
let that = this;
this.$vux.confirm.show({
'content': '您没有设置姓名，是否前往设置',
onConfirm: function () {
that.$router.push('/uc/setting')
}
})
}
} else {
this.$vux.loading.hide();
}
})
})
},
methods: {
showQrHandler() {
this.$vux.loading.show('获取中')
this.$http.get(this.tianYiWebUrl + '/wechat/uc/showQrCode').then(r => {
if (r.data.code === 500) {
this.$vux.alert.show({
title: '提示',
content: r.data.message
})
}
if (r.data.code === 200) {
this.qrCode = r.data.data;
this.showQr = true;
}
this.$vux.loading.hide();
})
},
jump(to) {
if (to === 'balance')
this.$router.push('/uc/balance');
if (to === 'order')
this.$router.push('/uc/order/all');
if (to === 'promise_balance')
this.$router.push('/uc/promisebalancelist')
if (to === 'integral')
this.$router.push('/uc/integral')
if (to === 'seller_recharge') {
window.location.href = '/html/uc/seller_recharge';
}
if (to === 'get_stock') {
window.location.href = '/html/shop/cate/9';
}
},
logout() {
this.$vux.toast.show('清理缓存');
this.$http.get(this.tianYiWebUrl + '/wechat/uc/logout').then(r => {
if (r.data.code === 200) {
window.location.reload()
}
})
},
/*签到*/
checkMe() {
this.$http.post(this.tianYiWebUrl + '/wechat/uc/myCheck').then(r => {
if (r.data.code === 200) {
this.$vux.alert.show({
'title': r.data.message,
'content': `本次获得 ${r.data.data.integralAmount} 个积分，明天继续哦！`
})
this.info.integral += r.data.data.integralAmount
this.info.checkInformation.todayChecked = true;
this.info.checkInformation.thisMonthCheckedTimes += 1
} else {
this.$vux.alert.show({
'title': r.data.message
})
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/Index.vue